module.exports = __webpack_public_path__ + "assets/img/btn-view-all-4a2212b4.png";